import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/messaging';
var config = {
  apiKey: 'AIzaSyD7Sc8qpMjxpEXh_rSHTS6v3QdL2ba-mRY',
  authDomain: 'grocart-de299.firebaseapp.com',
  databaseURL: 'https://grocart-de299.firebaseio.com',
  projectId: 'grocart-de299',
  storageBucket: 'grocart-de299.appspot.com',
  messagingSenderId: '120684768414',
  appId: '1:120684768414:web:732e0d879a9d317e56df8f',
  measurementId: 'G-MQZC5SYTHT',
};
var app = firebase.initializeApp(config);
const messaging = firebase.messaging();
messaging
  .getToken({
    vapidKey:
      'BEtI5Vcg0Wv8wqOWGdwMRSAV764LHON-ytEaeRoXgIUlG1wkDVYQyzRstHkciwb9yNNPTkEwaVRr69qfaCKXnKM',
  })
  .then(t => {
    console.log(t);
  });
messaging.onMessage(payload => {
  console.log('Message received. ', payload);
});

export default firebase;
